import {AppState} from "../types";

export const selectAlerts = (store: AppState) => store.alerts.alerts;

